export default __webpack_public_path__ + "static/media/blue-location.5492e0b8.svg";